import axios, { AxiosRequestConfig } from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers: { Accept: 'application/json' },
});

export const createRequestAuthInterceptor = (getState: () => { user: { data: { token: string } | null } }) => (config: AxiosRequestConfig) => {
    const state = getState();

    if (state.user.data?.token) {
        config.headers['X-AuthToken'] = state.user.data.token;
    }

    return config;
};

export { axiosInstance };
